/**
 *
 * Asynchronously loads the component for ValidatorsLeaderboard
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/ui/graphql/ValidatorsLeaderboard/loadable.js